import { Dropdown, Flex, Layout, Modal, Select } from "antd";
import styled from "styled-components";

export const WorkoutsLayout = styled(Layout)`
  margin: 0rem 0;
  background-color: transparent;
`;

export const StyledDropdown = styled(Dropdown)`
  direction: rtl;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  font-size: 14px;
  direction: rtl;
  height: 3rem;
`;

export const StyledSelectOption = styled.div`
  direction: rtl;
`;
